import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn:
    SENTRY_DSN ||
    'https://ba8a3bb15ca8450b9a97fbe2dc500a88@o57726.ingest.sentry.io/6629896',
  tracesSampleRate: 0,
});
